import { LoadingState } from "../../Common";
import {
  WorkflowImagesAction,
  WorkflowImagesActionType,
  IWorkflowImagesLoadedPayload,
  ISetWorkflowImagesErroredPayload
} from "../Actions/WorkflowImagesActions";
import { IconSet } from "../Models/IconSet";

export interface WorkflowImagesState {
  imageSets: IconSet[];
  loadingState: LoadingState;
  errorMessage: string;
  errorCode?: number;
}

const initialWorkflowImagesState: WorkflowImagesState = {
  imageSets: [],
  loadingState: {
    isLoaded: false,
    isLoading: false,
    errored: false
  },
  errorMessage: ""
};

const updateObject = (oldObject: any, newValues: any) => ({ ...oldObject, ...newValues });

const workflowImagesReducer = (
  workflowImagesState: WorkflowImagesState = initialWorkflowImagesState,
  action: WorkflowImagesAction
) => {
  switch (action.type) {
    case WorkflowImagesActionType.WORKFLOW_IMAGES_LOADED: {
      const payload = <IWorkflowImagesLoadedPayload>action.payload;

      const { loadedImageSets } = payload;

      return updateObject(workflowImagesState, {
        imageSets: loadedImageSets,
        loadingState: {
          isLoaded: true,
          isLoading: false,
          errored: false
        }
      });
    }
    case WorkflowImagesActionType.WORKFLOW_IMAGES_SET_LOADING: {
      return updateObject(workflowImagesState, {
        imageSets: [],
        loadingState: {
          isLoaded: false,
          isLoading: true,
          errored: false
        }
      });
    }
    case WorkflowImagesActionType.WORKFLOW_IMAGES_SET_ERRORED: {
      const payload = <ISetWorkflowImagesErroredPayload>action.payload;
      return updateObject(workflowImagesState, {
        imageSets: [],
        loadingState: {
          isLoaded: false,
          isLoading: false,
          errored: true
        },
        errorMessage: payload.errorMessage,
        errorCode: payload.errorCode
      });
    }
    default:
      return workflowImagesState;
  }
};

export default workflowImagesReducer;
